export const STATUS_NOT_LOADED = "NOT_LOADED";
export const LOGGED_IN = "LOGGED_IN";
export const NOT_LOGGED_IN = "NOT_LOGGED_IN";
export const LOADING = "LOADING";
export const LOADED = "LOADED";

export const FORMAT_TIME = "YYYY-MM-DD h:m A";
export const FORMAT_DATE_PICKER = "Y-MM-dd";
export const FORMAT_DATE_TIME_MOMENT = "Y-MM-D h:mm a";
export const FORMAT_DATE_MOMENT = "Y-MM-D";
export const FORMAT_DATETIME_MOMENT = "Y-MM-D h:mm A";

//STATUS ENTRY
export const STATUS_CREATED = 1;
export const STATUS_INACTIVE = 6;
export const STATUS_NO_STARTED = 7;
export const STATUS_IN_PROGRESS = 2;
export const STATUS_EXCUTED = 3;

export const TYPE_MOVEMENT_ENTRY="01";
export const TYPE_MOVEMENT_OUT="02";

export const TYPE_HAND_OUT = [
  { name: "Kits", code: "KT" },
  { name: "Consumo", code: "CM" },
  { name: "Solicitud", code: "SM" },
  { name: "Traslado S", code: "TS" },
  // { name: "Calidad", code: "CL" },
  // { name: "Corrección", code: "CR" },
  // { name: "Vencimiento de lote", code: "VL" }
];
export const TYPE_ENTRIES = [
  { name: "Remisión", code: "RE" },
  { name: "Factura", code: "FA" },
  { name: "Orden de compra", code: "OC" },
  { name: "Orden de requisición", code: "OR" },
  { name: "Otro", code: "TH" },
  { name: "Traslado E", code: "TE" },
];
export const TYPE_MOVEMENTS_DETAIL={ RE:"Remisión",FA:"Factura",OC:"Orden de compra",OR:"Orden de requisición",TH:"Otro",CL:"Calidad",CR:"Correción",KT:"Kits", CM:"Consumo" };

export const TYPE_MOVEMENTS = [
  { name: "Entradas", code: TYPE_MOVEMENT_ENTRY},
  { name: "Salidas", code: TYPE_MOVEMENT_OUT },
];

export const TYPE_TESTS = [
  { name: "Microbiológica", code: "01" },
  { name: "Química", code: "02" },
  { name: "Ematologíca", code: "03" },
  { name: "Fisioquímica", code: "04" },
];
export const STATUS_ENTRIES = [
  { name: "En proceso", code: STATUS_IN_PROGRESS },
  { name: "Finalizado", code: STATUS_EXCUTED }
];


export const TYPES_ITEMS = [
  { name: "Unidad", type: "00" },
{ name: "Longitud", type: "01" },
  { name: "Volumen", type: "02" },
  { name: "Masa", type: "03" },
  { name: "Presión", type: "04"},
];

//Stock Detail movement
export const STOCK_NOT_VAILABLE = "No hay stock suficiente para consumir";